module.exports = __webpack_public_path__ + "report_experience512.png";